import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../../utilities/requestClient';

export function useRestrictedListsOptions() {
  return useQuery({
    queryKey: ['restricted-lists-options'],
    queryFn: async () => {
      const response = await AxiosInstance.get('get_restricted_lists_options');
      return response.data;
    },
  });
}

export function useRestrictedCompaniesList(optionSelected: string | null) {
  return useQuery({
    queryKey: ['restricted-companies-list', optionSelected],
    queryFn: async () => {
      const response = await AxiosInstance.get(
        `/get_restricted_companies_list/${optionSelected}/`,
      );
      return response.data;
    },
    enabled: optionSelected !== null && optionSelected !== 'new-this-month',
  });
}

export function usePreviousMonthCompaniesList(optionSelected: string | null) {
  return useQuery({
    queryKey: ['previous-month-companies-list'],
    queryFn: async () => {
      const response = await AxiosInstance.get(
        '/get_new_sanctions',
      );
      return response.data;
    },
    enabled: optionSelected === 'new-this-month',
  });
}
